


import { defineComponent, onMounted, ref, onBeforeUnmount, onUnmounted } from 'vue';
import { MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import ChartBarTypeConst from '../../../../domain/Constants/ChartBarTypeConst';
import { Container } from 'inversify';
import BaseControlTypeConst from '../../../../domain/Constants/BaseControlTypeConst';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import { Dictionary } from '../../../../../expression/domain/dictionary';
import DataSourceConst from '@ilinium/shared/src/entidades/builder/crud/infrastructure/functions/dataSourceConst';
import { useStore } from 'vuex';	
import HelperCommon from '@ilinium/shared/src/common/infrastructure/funciones/HelperCommon';

export default defineComponent({
    name: 'dynamic_chart_bar',
    props:
    {
        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },

    },
    setup(props, context) {
        //
        
        const store = useStore();
        const { vmodel, loaded, getPropertyValue, getPropertyBooleanValue, getCatalogValue, getPropertyNumberValue, resolveExpressions, baseOnUnmount, fieldKey, fieldKeyComponentDataSourceId,
            getComponentDataSourceItemsFromId, getComponentDataSource } = ComponentCommon(props, context,store);
        const chartData = ref();
        const backgroundColor = ref();
        const borderColor = ref();
        const chartOptions = ref();
        const data = ref();
        const values = ref();
        const labels = ref();

        const showMessage = (msg: string) => {
            MessageService.showToast(MessageType.Correcto, '', msg)
        }
        const setChartData = () => {
            return {
                labels: labels.value,
                datasets: [
                    {
                        label: getPropertyValue(ChartBarTypeConst.LABEL),
                        data: values.value,
                        backgroundColor: backgroundColor.value,
                        borderColor: borderColor.value,
                        borderWidth: getPropertyNumberValue(ChartBarTypeConst.BORDERWIDTH)
                    }
                ]
            };
        };




        const setChartOptions = () => {

            return {
                plugins: {
                    legend: {
                        labels: {
                            color: getPropertyValue(ChartBarTypeConst.TEXTCOLOR)//color de la etiqueta
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: getPropertyValue(ChartBarTypeConst.TEXTCOLORHORIZONTALDATA)/*color de Q1, Q2*/
                        },
                        grid: {
                            color: getPropertyValue(ChartBarTypeConst.SURFACEHORIZONTALBORDER)/*color de las líneas del gráfico*/
                        }
                    },
                    y: {
                        beginAtZero: getPropertyBooleanValue(ChartBarTypeConst.BEGINATZERO),
                        ticks: {
                            color: getPropertyValue(ChartBarTypeConst.TEXTCOLORVERTICALDATA)/*Color del data*/
                        },
                        grid: {
                            color: getPropertyValue(ChartBarTypeConst.SURFACEVERTICALBORDER)
                        }
                    }
                }
            };
        }


        const getShortDescColumnName = (columnName: any) => {
            debugger

            const cds = getComponentDataSource(ChartBarTypeConst.DATA);

            if (cds && cds.dataSource.iapDataSourceFields) {

                const dataBaseId = cds?.dataSource?.iapDataSourceDataBase?.idBaseDatos;

                const dsf = cds.dataSource.iapDataSourceFields.find(x => (dataBaseId + DataSourceConst.DELIMITERFIELDS +(HelperCommon.isNullOrWhitespace( x.tableName)?DataSourceConst.AGGREGATE_TABLE:x.tableName) + DataSourceConst.DELIMITERFIELDS + (HelperCommon.isNullOrWhitespace( x.tableName)?x.fieldAlias:x.field)) == columnName);

                if (dsf) {
                    return dsf.shortDescription ?? dsf.description ?? (HelperCommon.isNullOrWhitespace( dsf.tableName)?dsf.fieldAlias:dsf.field);
                }


            }

            return columnName;
        }


        const getObjectFormatted = (_data: any) => {

            let newObject: any = {};

            for (var prop in _data) {
                if (_data.hasOwnProperty(prop)) {
                    newObject[getShortDescColumnName(prop)] = _data[prop];
                }
            }

            return newObject;
        }


        const getFirstColumnRowValues = (_data: any, colPosition: number) => {
            const rowValues =
                _data.map((obj: any) => {
                    const row = Object.values(obj)[colPosition];
                    return row;
                });


            return rowValues;
        }




        onMounted(() => {
            // resolveExpressions();

            data.value = getComponentDataSourceItemsFromId(ChartBarTypeConst.DATA);

            if (data.value) {

                if (getCatalogValue(ChartBarTypeConst.LABELDATA) == 'col') {
                    const valueFormatted = getObjectFormatted(data.value[0]);
                    values.value = Object.values(valueFormatted);
                    labels.value = Object.keys(valueFormatted);
                }
                else if (getCatalogValue(ChartBarTypeConst.LABELDATA) == 'row') {

                    labels.value = getFirstColumnRowValues(data.value, 0);
                    values.value = getFirstColumnRowValues(data.value, 1);

                }

            }
            backgroundColor.value = getPropertyValue(ChartBarTypeConst.BACKGROUNDCOLOR)?.split(';');
            borderColor.value = getPropertyValue(ChartBarTypeConst.BORDERCOLOR)?.split(';');
            chartData.value = setChartData();
            chartOptions.value = setChartOptions();



        })

        onUnmounted(() => {
            baseOnUnmount();
        })

        return {
            MessageService,
            MessageType,
            showMessage,
            getPropertyValue,
            getPropertyBooleanValue,
            vmodel,
            ChartBarTypeConst,
            getPropertyNumberValue,
            loaded,
            BaseControlTypeConst,
            fieldKey,
            fieldKeyComponentDataSourceId,
            chartData,
            chartOptions,
            getCatalogValue,



        };
    },
});
